import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$version/docs/$page")({
    beforeLoad: ({ params }) => {
        const pageNumber = Number(params.page);
        const page = Number.isInteger(pageNumber) && pageNumber > 1 ? pageNumber : undefined;
        throw redirect({
            to: "/$version/docs",
            params: { version: params.version },
            search: (prev) => ({ ...prev, page }),
            replace: true,
        });
    },
});
